import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import WithAuthZero from "./Auth0";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <WithAuthZero>
        <App />
      </WithAuthZero>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
